import { Component } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'cont-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class ContractorAppComponent {

  public unsupportedBrowser = false;
  public supportedBrowsers = ['chrome', 'edge', 'safari'];
  constructor(private readonly deviceService: DeviceDetectorService){
    
  }
  public ngOnInit(): void {
    const browserName = this.deviceService.browser.toLowerCase();
    this.unsupportedBrowser = !this.supportedBrowsers.some(browser =>
      browserName.includes(browser)
    );}

  }